export const sortByDistance = (origin, points, opts = {}) => {
    const newPoints = JSON.parse(JSON.stringify(points));
    newPoints.sort((a, b) => {
        a.distance = distanceBetweenPoints(origin, a);
        b.distance = distanceBetweenPoints(origin, b);

        return a.distance - b.distance;
    });

    return newPoints;
};

const distanceBetweenPoints = (p1, p2) => {
    return Math.abs(
        Math.sqrt((p1.y - p2.y) * (p1.y - p2.y) + (p1.x - p2.x) * (p1.x - p2.x))
    );
};
